/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlVerifyResponse
 */
export interface ControlVerifyResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlVerifyResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlVerifyResponse
     */
    scope: Array<string>;
}

/**
 * Check if a given object implements the ControlVerifyResponse interface.
 */
export function instanceOfControlVerifyResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roles" in value;
    isInstance = isInstance && "scope" in value;

    return isInstance;
}

export function ControlVerifyResponseFromJSON(json: any): ControlVerifyResponse {
    return ControlVerifyResponseFromJSONTyped(json, false);
}

export function ControlVerifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerifyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roles': json['roles'],
        'scope': json['scope'],
    };
}

export function ControlVerifyResponseToJSON(value?: ControlVerifyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roles': value.roles,
        'scope': value.scope,
    };
}

